<template>
	<div class="image-gallery">
    <a href="#" @click.prevent="$emit('closeGallery')" class="image-gallery__close">
      <svg viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.94148 0L24.9958 22.0975L22.0554 25.0449L0 2.94634L2.94148 0Z" fill="#FFFFFF"/>
      <path d="M25 2.94738L2.94356 25.048L0.0010376 22.0996L22.0575 0L25 2.94738Z" fill="#FFFFFF"/>
      </svg>
    </a>
    <div class="image-gallery__number">{{ activeSlide }}/{{ images.edges.length }}</div>
    <flickity @init="getActiveSlide()" class="image-gallery__slider" ref="flickity" :options="flickityOptions">
        <div class="carousel-cell"
          v-for="(thumb, thumbIndex) in images.edges"
          :key="thumbIndex"
        >
          <img :src="thumb.node.imageUrl">
        </div>
    </flickity>
    <div @click.prevent="$emit('closeGallery')" class="image-gallery__backdrop"></div>
	</div>
</template>

<script>
// @ is an alias to /src
import Flickity from 'vue-flickity';

export default {
  name: 'ImageGallery',
  data: () => ({
    activeSlide: 1,
    flickityOptions: {
      initialIndex: 0,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: true
      // any options from Flickity can be used
    }
  }),
  components: {
    Flickity
  },
  props: {
    images: {
      default: null,
      type: Object
    },
    index: {
      default: 0,
      type: Number
    }
  },
  watch: {
  },
  created () {
    this.flickityOptions.initialIndex = this.index
  },
  mounted () {
  },
  methods: {
    getActiveSlide () {
      var self = this
      this.activeSlide = this.$refs.flickity.selectedIndex() + 1
      this.$refs.flickity.on('change', function () {
        self.activeSlide = self.$refs.flickity.selectedIndex() + 1
      })
    }
  }
}
</script>

<style lang="scss">
    .flickity-slider {
        position: absolute !important;
        width: 100% !important;
        height: 100% !important;
        display: flex !important;
        align-items: center !important;
    }
</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped="true">
@import "../../scss/global/includes";


.image-gallery {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(#000000, 0.95);
  z-index: 1009;

  ::v-deep .flickity-prev-next-button.previous {
    left: -5vw;
  }

  ::v-deep .flickity-prev-next-button.next {
    right: -5vw;
  }

  ::v-deep .flickity-prev-next-button {
    width: 40px;
    height: 40px;
  }

}

.image-gallery__backdrop {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(#000000, 0.95);
}

.image-gallery__slider {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 80%;
  @include transform(translate(-50%, -50%));
  z-index: 1001;

  .carousel-cell {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-height: 100%;
      display: block;
    }
  }

}

.image-gallery__number {
  position: fixed;
  top: 30px;
  left: 50%;
  @include transform(translate(-50%, 0));
  z-index: 1004;
  font-size: 14px;
  color: #FFFFFF;
  font-family: $font-regular;
}

.image-gallery__close {
  position: fixed;
  top: 90px;
  right: 20px;
  z-index: 1004;
  font-size: 14px;
  display: flex;
  gap: 10px;
  color: #FFFFFF;
  font-family: $font-regular;

  svg {
    width: 11px;
  }
}

</style>
